/* eslint-disabled */
import ItemType from "./ItemType";
import Property from "./Property";
import Pack from "./Pack";
import ItemGuarantee from "./ItemGuarantee";
import Contract from "./Contract";
import DemandeAttestation from "./DemandeAttestation";
import BrownCard from "./BrownCard";
import PremiumDetail from "./PremiumDetail";
import Avenant from "./Avenant";
import Folder from "./Folder";
import ItemExtend from "@/entity/extends/ItemExtend";
import Coverage from "@/entity/Coverage";
import { hydrateCollection } from "@/Utils/EntityHelper";

export default class Item extends ItemExtend {

    public id!: number;
    public model!: ItemType;
    public properties: Array<Property> = [];
    public parent!: Property;
    public name? = '';
    public pack?: Pack;
    public guarantees: Array<ItemGuarantee> = [];
    public beneficiary!: Item;
    public benefits: Array<Item> = [];
    public contract!: Contract;
    public defaultAlias? = '';
    public premium?: number;
    public addedAt?: Date;
    public details = [];
    public demandeAttestations: Array<DemandeAttestation> = [];
    public params :any[] = [];
    public brownCard!: BrownCard;
    public customData = [];
    public premiumDetails: Array<PremiumDetail> = [];
    public removedAt?: Date;
    public addedByAvenants: Array<Avenant> = [];
    public removedByAvenants: Array<Avenant> = [];
    public coverages: Array<Coverage> = [];
    public uuid = '';
    public createdAt?: Date;
    public updatedAt?: Date;
    public createBy? = '';
    public updateBy? = '';
    public removeBy? = '';
    public createdFromIp? = '';
    public updatedFromIp? = '';
    public deletedAt?: Date;
    public folder!: Folder;

    constructor(object?: any) {
        super(object)
        if (object) {
            this.id = object.id;
            this.model = (object.model instanceof ItemType) ? object.model : object.model ? new ItemType(object.model) : object.model;
            hydrateCollection(object.properties, Property, this.properties);
            this.parent = (object.parent instanceof Property) ? object.parent : object.parent ? new Property(object.parent) : object.parent;
            this.name = object.name;
            this.pack = (object.pack instanceof Pack) ? object.pack : object.pack ? new Pack(object.pack) : object.pack;
            hydrateCollection(object.guarantees, ItemGuarantee, this.guarantees);
            this.beneficiary = (object.beneficiary instanceof Item) ? object.beneficiary : object.beneficiary ? new Item(object.beneficiary) : object.beneficiary;
            hydrateCollection(object.benefits, Item, this.benefits);
            this.contract = (object.contract instanceof Contract) ? object.contract : object.contract ? new Contract(object.contract) : object.contract;
            this.defaultAlias = object.defaultAlias;
            this.premium = object.premium;
            if (object.addedAt) {
                this.addedAt = new Date(object.addedAt);
            }
            this.details = object.details;
            hydrateCollection(object.demandeAttestations, DemandeAttestation, this.demandeAttestations);
            this.params = object.params;
            this.brownCard = (object.brownCard instanceof BrownCard) ? object.brownCard : object.brownCard ? new BrownCard(object.brownCard) : object.brownCard;
            this.customData = object.customData;
            hydrateCollection(object.premiumDetails, PremiumDetail, this.premiumDetails);
            if (object.removedAt) {
                this.removedAt = new Date(object.removedAt);
            }
            hydrateCollection(object.addedByAvenants, Avenant, this.addedByAvenants);
            hydrateCollection(object.removedByAvenants, Avenant, this.removedByAvenants);
            hydrateCollection(object.coverages, Coverage, this.coverages);
            this.uuid = object.uuid;
            if (object.createdAt) {
                this.createdAt = new Date(object.createdAt);
            }
            if (object.updatedAt) {
                this.updatedAt = new Date(object.updatedAt);
            }
            this.createBy = object.createBy;
            this.updateBy = object.updateBy;
            this.removeBy = object.removeBy;
            this.createdFromIp = object.createdFromIp;
            this.updatedFromIp = object.updatedFromIp;
            if (object.deletedAt) {
                this.deletedAt = new Date(object.deletedAt);
            }
            this.folder = (object.folder instanceof Folder) ? object.folder : object.folder ? new Folder(object.folder) : object.folder;
        }
        this.postConstruct()
    }

}
